(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Global sound switch ---------- */
  const SOUND_KEY = 'bb_sound';
  let soundOn = false;
  try { soundOn = sessionStorage.getItem(SOUND_KEY) === '1'; } catch (e) {}
  const setSound = (on) => {
    soundOn = on;
    try { sessionStorage.setItem(SOUND_KEY, on ? '1' : '0'); } catch (e) {}
    document.querySelectorAll('[data-sound-switch]').forEach((b) => b.setAttribute('aria-checked', String(on)));
    document.querySelectorAll('[data-intro-sound]').forEach((b) => b.setAttribute('aria-pressed', String(on)));
  };

  /* ---------- Sound (built-in fallbacks via Web Audio) ---------- */
  let ctx = null;
  const audio = () => (ctx = ctx || new (window.AudioContext || window.webkitAudioContext)());

  function playFile(url) {
    const a = new Audio(url);
    a.play().catch(() => {});
    return a;
  }

  function moo() {
    const ac = audio(), t = ac.currentTime;
    const osc = ac.createOscillator(), filt = ac.createBiquadFilter(), g = ac.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(150, t);
    osc.frequency.linearRampToValueAtTime(175, t + 0.35);
    osc.frequency.linearRampToValueAtTime(105, t + 1.3);
    filt.type = 'lowpass';
    filt.frequency.setValueAtTime(400, t);
    filt.frequency.linearRampToValueAtTime(900, t + 0.4);
    filt.frequency.linearRampToValueAtTime(350, t + 1.3);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.35, t + 0.15);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 1.4);
    osc.connect(filt).connect(g).connect(ac.destination);
    osc.start(t); osc.stop(t + 1.45);
  }

  function sizzle(seconds = 2.2, level = 0.25) {
    const ac = audio(), t = ac.currentTime;
    const len = Math.floor(ac.sampleRate * seconds);
    const buf = ac.createBuffer(1, len, ac.sampleRate), d = buf.getChannelData(0);
    for (let i = 0; i < len; i++) {
      const crackle = Math.random() < 0.002 ? (Math.random() * 2 - 1) * 3 : 0;
      d[i] = (Math.random() * 2 - 1) * 0.5 + crackle;
    }
    const src = ac.createBufferSource(), hp = ac.createBiquadFilter(), g = ac.createGain();
    src.buffer = buf;
    hp.type = 'highpass'; hp.frequency.value = 2500;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(level, t + 0.08);
    g.gain.setValueAtTime(level, t + seconds * 0.6);
    g.gain.exponentialRampToValueAtTime(0.0001, t + seconds);
    src.connect(hp).connect(g).connect(ac.destination);
    src.start(t);
  }

  /* ---------- Opening animation ---------- */
  function initIntro(root) {
    const el = root.querySelector('[data-intro]');
    if (!el) return;
    const KEY = 'bb_intro_seen';
    const cow = el.querySelector('[data-intro-cow]');
    const grill = el.querySelector('[data-intro-grill]');
    const soundBtn = el.querySelector('[data-intro-sound]');
    const skipBtn = el.querySelector('[data-intro-skip]');
    let timers = [], done = false;

    const clear = () => { timers.forEach(clearTimeout); timers = []; };
    const finish = () => {
      if (done) return; done = true; clear();
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      el.classList.add('is-leaving');
      setTimeout(() => { el.hidden = true; el.classList.remove('is-leaving'); document.body.classList.remove('intro-open'); }, reduceMotion ? 0 : 500);
    };
    const sound = (kind) => {
      if (!soundOn) return;
      const url = kind === 'moo' ? el.dataset.moo : el.dataset.sizzle;
      if (url) playFile(url); else if (kind === 'moo') moo(); else sizzle();
    };

    const play = () => {
      done = false; clear();
      el.hidden = false; document.body.classList.add('intro-open');
      cow.classList.add('is-on'); grill.classList.remove('is-on');
      sound('moo');
      const step = reduceMotion ? 1200 : 2000;
      timers.push(setTimeout(() => { cow.classList.remove('is-on'); grill.classList.add('is-on'); sound('sizzle'); }, step));
      timers.push(setTimeout(finish, step * 2.2));
      skipBtn.focus({ preventScroll: true });
    };

    soundBtn.setAttribute('aria-pressed', String(soundOn));
    soundBtn.addEventListener('click', () => {
      setSound(!soundOn);
      if (soundOn) sound(grill.classList.contains('is-on') ? 'sizzle' : 'moo');
    });
    skipBtn.addEventListener('click', finish);
    el.addEventListener('keydown', (e) => { if (e.key === 'Escape') finish(); });

    let seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (!designMode && !seen) play();
    el._play = play;
  }

  /* ---------- Header nav toggle ---------- */
  function initNav() {
    const btn = document.querySelector('[data-nav-toggle]');
    const nav = document.getElementById('mobile-nav');
    if (btn && nav) {
      btn.addEventListener('click', () => {
        nav.hidden = !nav.hidden;
        btn.setAttribute('aria-expanded', String(!nav.hidden));
      });
    }
    document.querySelectorAll('[data-sound-switch]').forEach((b) => {
      b.setAttribute('aria-checked', String(soundOn));
      b.addEventListener('click', () => { setSound(!soundOn); if (soundOn) { try { sizzle(0.6, 0.15); } catch (e) {} } });
    });
  }

  /* ---------- Promo slider ---------- */
  function initSlider(root) {
    root.querySelectorAll('[data-slider]').forEach((track) => {
      const slides = [...track.children];
      const dots = [...(track.parentElement.querySelector('[data-slider-dots]')?.children || [])];
      if (slides.length < 2) return;
      let i = 0, paused = false;
      const go = (n) => { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); };
      const mark = () => dots.forEach((d, n) => d.setAttribute('aria-current', String(n === i)));
      track.addEventListener('scroll', () => { i = Math.round(track.scrollLeft / track.clientWidth); mark(); }, { passive: true });
      dots.forEach((d, n) => d.addEventListener('click', () => go(n)));
      ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => track.addEventListener(ev, () => (paused = true), { passive: true }));
      ['pointerleave', 'focusout'].forEach((ev) => track.addEventListener(ev, () => (paused = false)));
      const ms = (parseInt(track.dataset.interval, 10) || 5) * 1000;
      if (!reduceMotion) setInterval(() => { if (!paused && !document.hidden) go(i + 1); }, ms);
    });
  }

  /* ---------- Menu marquee + detail dialog ---------- */
  function initMenu(root) {
    root.querySelectorAll('[data-marquee]').forEach((vp) => {
      const track = vp.querySelector('[data-marquee-track]');
      if (!track || !track.children.length) return;
      // Duplicate items so the loop is seamless. Clones are hidden from assistive tech.
      const originals = [...track.children];
      originals.forEach((li) => {
        const c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('button, a').forEach((b) => b.setAttribute('tabindex', '-1'));
        track.appendChild(c);
      });
      const speed = parseInt(vp.dataset.speed, 10) || 35; // px per second
      let paused = reduceMotion, last = 0, resumeT, pos = 0;
      const pause = () => { paused = true; clearTimeout(resumeT); };
      const resume = (delay = 1500) => { clearTimeout(resumeT); if (!reduceMotion) resumeT = setTimeout(() => { paused = false; pos = vp.scrollLeft; }, delay); };
      const tick = (t) => {
        const dt = last ? (t - last) / 1000 : 0; last = t;
        if (!paused && !document.hidden) {
          const half = track.scrollWidth / 2;
          pos += speed * dt;
          if (pos >= half) pos -= half;
          vp.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      };
      vp.addEventListener('scroll', () => {
        const half = track.scrollWidth / 2;
        if (paused && vp.scrollLeft >= half) vp.scrollLeft -= half;
      }, { passive: true });
      vp.addEventListener('pointerenter', pause);
      vp.addEventListener('pointerleave', () => resume(600));
      vp.addEventListener('touchstart', pause, { passive: true });
      vp.addEventListener('touchend', () => resume(), { passive: true });
      vp.addEventListener('focusin', pause);
      vp.addEventListener('focusout', () => resume());

      // Mouse drag to scroll
      let down = false, startX = 0, startL = 0, moved = false;
      vp.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startL = vp.scrollLeft; vp.classList.add('is-dragging'); });
      window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; vp.scrollLeft = startL - dx; });
      window.addEventListener('pointerup', () => { if (!down) return; down = false; vp.classList.remove('is-dragging'); });
      vp.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);

      requestAnimationFrame(tick);
    });

    root.querySelectorAll('.menu').forEach((sec) => {
      const dialog = sec.querySelector('[data-menu-dialog]');
      const body = sec.querySelector('[data-menu-dialog-body]');
      if (!dialog || !body) return;
      sec.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-menu-open]');
        if (!btn) return;
        const tpl = btn.parentElement.querySelector('template[data-menu-detail]');
        if (!tpl) return;
        body.replaceChildren(tpl.content.cloneNode(true));
        if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', '');
      });
      sec.querySelector('[data-menu-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    });
  }

  /* ---------- Smash game ---------- */
  function initSmash(root) {
    root.querySelectorAll('[data-smash]').forEach((stage) => {
      const sec = stage.closest('.smash');
      const hit = stage.querySelector('[data-smash-hit]');
      const prompt = sec.querySelector('[data-smash-prompt]');
      const after = sec.querySelector('[data-smash-after]');
      const cta = stage.querySelector('.smash__cta');
      const reset = sec.querySelector('[data-smash-reset]');
      const ctaText = cta.textContent;
      let n = 0;
      const set = (v) => { n = v; stage.dataset.stage = String(v); };
      hit.addEventListener('click', () => {
        if (n >= 4) return;
        set(n + 1);
        stage.classList.remove('is-shake'); void stage.offsetWidth; stage.classList.add('is-shake');
        if (navigator.vibrate) navigator.vibrate(25);
        if (soundOn) { try { sizzle(n === 3 ? 1.8 : 0.35, n === 3 ? 0.28 : 0.15); } catch (e) {} }
        if (n < 3) prompt.textContent = prompt.dataset.mid;
        if (n === 3) setTimeout(() => { set(4); prompt.textContent = prompt.dataset.end; after.hidden = false; cta.textContent = ''; }, reduceMotion ? 0 : 700);
      });
      reset.addEventListener('click', () => { set(0); prompt.textContent = prompt.dataset.start; after.hidden = true; cta.textContent = ctaText; hit.focus(); });
    });
  }

  /* ---------- Cart count refresh after add ---------- */
  document.addEventListener('pageshow', () => {
    const el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch('/cart.js').then((r) => r.json()).then((c) => { el.textContent = c.item_count; }).catch(() => {});
  });

  function initAll(root = document) {
    initIntro(root); initSlider(root); initMenu(root); initSmash(root);
  }

  initNav();
  initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const intro = e.target.querySelector('[data-intro]');
    if (intro && intro._play) intro._play();
  });
})();
